export const endpoints = {
  list: () => `/families/payments/due/`,
};
